﻿import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/pg_sistema/sistema-anexos";

export const Route = createFileRoute("/_authenticated/sistema-anexos")({
  head: () => ({
    meta: [
      { title: "Anexos — Milky Moo Palmares" },
      {
        name: "description",
        content: "Listagem de todos os arquivos anexados na aplicação, com download e exclusão.",
      },
      { property: "og:title", content: "Anexos — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Listagem de todos os arquivos anexados na aplicação, com download e exclusão.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
